import { render, staticRenderFns } from "./IssueReportPackageNameCreate.vue?vue&type=template&id=a61417e4&scoped=true&"
var script = {}
import style0 from "./IssueReportPackageNameCreate.vue?vue&type=style&index=0&id=a61417e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61417e4",
  null
  
)

export default component.exports